import { FETCH_COMMENT_RESPONSE_FAILURE, FETCH_COMMENT_RESPONSE_REQUEST, FETCH_COMMENT_RESPONSE_SUCCESS } from "./commentResponseTypes";

const initialState = {
  loading: true,
  data: [],
  errorMsg: '',
};


const commentResponseReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COMMENT_RESPONSE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_COMMENT_RESPONSE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        errorMsg: '',
      };
    case FETCH_COMMENT_RESPONSE_FAILURE:
      return {
        ...state,
        loading: false,
        data: [],
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default commentResponseReducer